<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 10px 0 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.pileItem-div {
  font-weight: 600;
  //   margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;
  align-items: center;

  >div:first-of-type {
    width: 140px;
    text-align: right;
    padding-right: 8px;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    flex: 1;
    min-width: 0;
    text-align: left;
  }
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">共享充电订单详情</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <div class="title-div">订单信息</div>
        <el-row :gutter="20">
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">充电订单编号</div>
            <div>{{ detailForm.orderNo || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">充电设备编号/IMEI</div>
            <div>{{ detailForm.pileCode || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">充电业务归属</div>
            <div>{{ detailForm.bindSourceName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">订单状态</div>
            <div>{{ detailForm.shareOrderStatusName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">共享设备类型</div>
            <div>{{ detailForm.deviceTypeName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">共享充电类型</div>
            <div>{{ detailForm.shareStartTypeName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">订单类型</div>
            <div>{{ detailForm.shareOrderTypeName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">充电用户账号类型</div>
            <div>{{ detailForm.custTypeName || "-" }}</div>
          </el-col>
          <!-- <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">设备所属用户手机号</div>
            <div>{{ detailForm.mobile || "-" }}</div>
          </el-col> -->
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">用户手机号</div>
            <div>{{ detailForm.custMobile || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">充电用户手机号</div>
            <div>{{ detailForm.custPhone || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">订单属性</div>
            <div>{{ detailForm.orderPropertyName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">启动方式</div>
            <div>{{ detailForm.shareStartTypeName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">结束方式</div>
            <div>{{ detailForm.chargeOverReason || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">开始时间</div>
            <div>{{ detailForm.beginTime || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">结束时间</div>
            <div>{{ detailForm.endTime || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">充电电量(kWh)</div>
            <div>{{ detailForm.chargeVal || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">充电时长</div>
            <div>{{ detailForm.chargeMinDesc || "-" }}</div>
          </el-col>
        </el-row>

        <div class="title-div" style="display:flex;justify-content:space-between;align-items:center;">
          <span>充电费用明细</span>
          <el-button type="primary" size="small" :disabled="refundBtnDisabled" @click="openRefundDialog">
            售后退款
          </el-button>
        </div>
        <el-table class="el-table" :data="chargePayFeeInfo" border max-height="500px"
          style="width: 100%; margin: 20px auto" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
            background: '#FAFAFA',
            color: '#8F9BB3',
            fontSize: '14px',
            textAlign: 'center',
            border: '1px solid #F0F0F0',
          }">
          <el-table-column align="center" prop="outTradeNo" width="400" label="支付流水号" />
          <el-table-column align="center" prop="preReturnTradeNo" label="预付退款流水号" width="360" />
          <el-table-column align="center" label="充电时段" width="200">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.chargeTimeSlot" :key="index" 
                   style="padding: 8px 0; border-bottom: 1px solid #EBEEF5;">
                {{ item || '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="当前时段充电单价（元）" width="240">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.currentTimeChargeUnit" :key="index" 
                   style="padding: 8px 0; border-bottom: 1px solid #EBEEF5;">
                {{ item || '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="桩主自定义电价（元）" width="240">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.owenFreeFee" :key="index" 
                   style="padding: 8px 0; border-bottom: 1px solid #EBEEF5;">
                {{ item || '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="桩主自定义服务费（元）" width="240">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.owenServFee" :key="index" 
                   style="padding: 8px 0; border-bottom: 1px solid #EBEEF5;">
                {{ item || '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="prePayFee" label="充电预付费用（元）" width="240" />
          <el-table-column align="center" prop="actPayFee" label="充电实付费用（元）" width="240" />
          <el-table-column align="center" prop="preAmtPayFee" label="已退预付费用（元）" width="240" />
          <el-table-column align="center" prop="ownerProfit" label="桩主收益（元）" width="240" />
          <el-table-column align="center" prop="zeedaProfit" label="平台服务费（元）" width="240" />
          <el-table-column align="center" prop="huifuPaymentFee" label="支付手续费（元）" width="240" />
          <el-table-column align="center" prop="profitTime" label="收益到账时间" width="240" />
          <el-table-column align="center" prop="preReturnStatusName" label="预付退款状态" width="240" />
          <el-table-column align="center" prop="transFinishTime" label="预付退款时间" width="240" />
          <el-table-column align="center" prop="tradeSuccessTime" label="支付创建时间" width="240" />
        </el-table>
        <div>
          服务费率计算规则：平台服务费0.1元/度电；活动除外
        </div>

        <div class="title-div">售后退款明细</div>
        <el-table :data="afterSalePayFeeInfo" border :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background:'#FAFAFA', color:'#8F9BB3', fontSize:'14px', textAlign:'center', border:'1px solid #F0F0F0' }"
          max-height="500px" style="width:100%;margin-bottom:12px;">
          <el-table-column prop="batchNo" label="退款批次号" align="center" min-width="140" />
          <el-table-column prop="refundSeqNo" label="退款流水号" align="center" min-width="140" />
          <el-table-column label="退款对象" align="center" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.refundTarget === 'CHARGER' ? '充电用户' : (scope.row.refundTarget === 'OWNER' ? '桩主' : scope.row.refundTarget) }}
            </template>
          </el-table-column>
          <el-table-column prop="ordAmt" label="退款金额" align="center" min-width="100" />
          <el-table-column prop="refundReason" label="退款原因" align="center" min-width="100" />
          <el-table-column label="退款状态" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.transStat === 'P'" style="color:#409EFF;">● 退款中</span>
              <span v-else-if="scope.row.transStat === 'S'" style="color:#67C23A;">● 已退款</span>
              <span v-else-if="scope.row.transStat === 'F'" style="color:#F56C6C;">● 退款失败</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdWhen" label="申请时间" align="center" min-width="160" />
          <el-table-column prop="transFinishTime" label="完成时间" align="center" min-width="160">
            <template slot-scope="scope">{{ scope.row.transFinishTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="createdByName" label="操作人" align="center" min-width="100" />
        </el-table>

        <div class="title-div">设备信息</div>
        <el-row :gutter="20">
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">设备编号</div>
            <div>{{ detailForm.pileCode || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">设备名称</div>
            <div>{{ detailForm.stationName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">设备型号</div>
            <div>{{ deviceInfo.typeName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">厂家/厂商代码</div>
            <div>{{ deviceInfo.manufactureCode || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">绑定方式</div>
            <div>{{ deviceInfo.deviceTypeName || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">联网方式</div>
            <div>{{ deviceInfo.onlineConnectType || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">电流采集</div>
            <div>{{ deviceInfo.currentValueCollect || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">电压采集</div>
            <div>{{ deviceInfo.voltageValueCollect || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">电量采集</div>
            <div>{{ deviceInfo.powerDataCollect || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">温度采集</div>
            <div>{{ deviceInfo.tempDataCollect || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">保护功能</div>
            <div>{{ deviceInfo.protectFunction || "-" }}</div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
            <div class="cust-detail-title">指示灯</div>
            <div>{{ deviceInfo.signalLight || "-" }}</div>
          </el-col>
        </el-row>

        <div class="title-div">共享价格时段</div>
        <el-table class="el-table" :data="shareTimeInfo" border max-height="500px"
          style="width: 100%; margin: 20px auto" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
            background: '#FAFAFA',
            color: '#8F9BB3',
            fontSize: '14px',
            textAlign: 'center',
            border: '1px solid #F0F0F0',
          }">
          <el-table-column align="center" type="index" width="220" label="序号" />
          <el-table-column align="center" label="时间段">
            <template slot-scope="scope">
              {{ scope.row.startTime || "-" }} - {{ scope.row.endTime || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="chargeVal" label="电费（元/度）" width="220" />
          <el-table-column align="center" prop="serviceOwnerVal" label="服务费（元/度）" width="220" />
        </el-table>

        <!-- <div class="flex-r-end margin-t-20">
          <button class="common-empty-button" @click="back()">返 回</button>
        </div> -->
      </div>
    </div>

    <el-dialog title="售后退款" :visible.sync="refundVisible" width="650px" :close-on-click-modal="false">
      <!-- 资金来源提示 -->
      <el-alert type="warning" :closable="false" show-icon
        title="本操作从平台商户余额发起退款，非原路退回" style="margin-bottom:12px;" />
      <!-- T+1 结算状态提示 -->
      <el-alert v-if="isWhitelistOrder === 'Y'" type="error" :closable="false" show-icon
        title="白名单用户充电订单，充电用户不支持退款" style="margin-bottom:12px;" />
      <el-alert v-else-if="ownerProfitStatus === 'PENDING'" type="success" :closable="false" show-icon
        title="未分账，支持退充电用户" style="margin-bottom:12px;" />
      <el-alert v-else-if="ownerProfitStatus === 'SETTLED'" type="error" :closable="false" show-icon
        title="当前订单已超过T+1结算期，已分账，充电用户不支持退款" style="margin-bottom:12px;" />
      <!-- 已完结但收益记录未生成(初始化失败/延迟)：无余额可算且后端会拒绝，不可退充电用户 -->
      <el-alert v-else-if="detailForm.shareOrderStatus === 'CLOSED' && !ownerProfitStatus" type="warning" :closable="false" show-icon
        title="订单已完结但收益记录未生成（可能初始化延迟或失败），暂不支持退充电用户" style="margin-bottom:12px;" />
      <!-- 可退余额 -->
      <div v-if="ownerProfitStatus === 'PENDING'" style="margin-bottom:12px;color:#F56C6C;">
        充电用户可退余额：￥{{ refundableBalance }}
      </div>

      <!-- 退款对象 -->
      <div style="font-weight:bold;color:#303133;margin-bottom:12px;">退款对象（支持多选，全选表示同时退双方）</div>
      <el-form :model="refundForm" label-width="0">
        <!-- 退给充电用户 -->
        <el-form-item>
          <div style="display:flex;align-items:center;gap:8px;flex-wrap:nowrap;">
            <el-checkbox v-model="refundForm.chargerChecked" :disabled="chargerRefundDisabled"
              :class="{ 'charger-disabled': chargerRefundDisabled }"
              @change="onChargerChange">
              退给充电用户
              <span v-if="chargerRefundDisabled" style="color:#F56C6C;">
                （{{ isWhitelistOrder === 'Y' ? '白名单用户' : (ownerProfitStatus === 'SETTLED' ? '已分账' : '收益未生成') }}）
              </span>
            </el-checkbox>
            <span style="color:#909399;white-space:nowrap;">手机号：{{ detailForm.custPhone || '-' }}</span>
            <el-input-number v-model="refundForm.chargerAmt" :disabled="chargerRefundDisabled"
              :min="0" :max="refundableBalance" :precision="2" size="small" />
          </div>
        </el-form-item>
        <!-- 退给桩主 -->
        <el-form-item>
          <div style="display:flex;align-items:center;gap:8px;flex-wrap:nowrap;">
            <el-checkbox v-model="refundForm.ownerChecked">
              退给桩主
            </el-checkbox>
            <span style="color:#909399;white-space:nowrap;">手机号：{{ detailForm.custMobile || '-' }}</span>
            <el-input-number v-model="refundForm.ownerAmt"
              :min="0" :precision="2" size="small" />
            <span style="color:#909399;white-space:nowrap;">（无金额上限）</span>
          </div>
        </el-form-item>
      </el-form>

      <div style="font-weight:bold;color:#303133;margin:12px 0 8px 0;">退款原因</div>
      <el-select v-model="refundForm.refundReason" placeholder="请选择" style="width:100%;">
        <el-option label="用户申请" value="用户申请" />
        <el-option label="平台测算" value="平台测算" />
        <el-option label="其他" value="其他" />
      </el-select>

      <div style="font-weight:bold;color:#303133;margin:12px 0 8px 0;">备注</div>
      <el-input type="textarea" v-model="refundForm.remark" style="width:100%;" />

      <span slot="footer" class="dialog-footer">
        <button class="common-empty-button" @click="refundVisible = false">取 消</button>
        <button class="common-bg-button" :disabled="refundSubmitting" @click="submitRefund">确定退款</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    var self = this;
    return {
      pageConfig,
      detailBreadCrumb: pageConfig.detailBreadCrumb,
      orderNo: "",
      detailForm: {},
      chargePayFeeInfo: [],
      afterSalePayFeeInfo: [],
      deviceInfo: {},
      shareTimeInfo: [],

      refundVisible: false,
      refundForm: {
        orderNo: '',
        refundReason: '',
        remark: '',
        // 退款对象勾选 + 金额
        chargerChecked: false,   // 退给充电用户
        chargerAmt: 0,           // 充电用户退款金额
        ownerChecked: false,     // 退给桩主
        ownerAmt: 0,             // 桩主退款金额
      },
      // 订单级退款辅助数据(来自 getChargeOrderInfo 的 pileOrderChargeOrderVO, 即 detailForm)
      ownerProfitStatus: '',     // PENDING / SETTLED
      refundableBalance: 0,      // 充电用户可退余额
      isWhitelistOrder: '',      // 是否白名单用户订单 Y/N（从列表页路由参数传入）
      // 充电用户手机号=detailForm.custPhone; 桩主手机号=detailForm.custMobile(均已在 init() 加载, 无需额外请求)
      refundSubmitting: false,   // 提交防抖
      refundPollTimer: null,     // 异步轮询定时器
    };
  },
  computed: {
    // 仅「已支付/已完成」允许售后退款; 注意后端已完成=CLOSED
    refundBtnDisabled() {
      const s = (this.detailForm && this.detailForm.shareOrderStatus) || '';
      return s !== 'PAYED' && s !== 'CLOSED';
    },
    // 已分账(SETTLED)、白名单用户充电、或已完结但收益记录未生成(初始化失败/延迟，后端不下发状态且余额为0) 时充电用户不可退
    chargerRefundDisabled() {
      return this.ownerProfitStatus === 'SETTLED' || this.isWhitelistOrder === 'Y'
        || (this.detailForm.shareOrderStatus === 'CLOSED' && !this.ownerProfitStatus);
    },
  },
  methods: {
    init() {
      let _ = this;
      _.orderNo = _.$route.query.orderNo || null;
      _.isWhitelistOrder = _.$route.query.isWhitelistOrder || '';
      if (_.orderNo) {
        _.$U.showLoading(_);
        _.$H
          .post(_, _.$A.digitization.getChargeOrderInfo, { orderNo: _.orderNo })
          .then((res) => {
            const list = res.data.data || {};
            _.detailForm = list.pileOrderChargeOrderVO || {};
            _.chargePayFeeInfo = list.chargingFeeDetail || [];
            _.afterSalePayFeeInfo = list.afterSalesRefundFeeDetail || [];
            // 售后退款弹窗辅助数据(后端注入)
            _.ownerProfitStatus = list.ownerProfitStatus || '';
            _.refundableBalance = list.refundableBalance || 0;
            _.deviceInfo = list.chargeLockTypeEntity || {};
            _.shareTimeInfo = list.deviceSharePriceSettingEntity.customizeList || [];
            _.$U.hideLoading(_);
          }).catch(() => {
            _.$U.hideLoading(_);
          });
      }
    },
    back() {
      this.$router.go(-1);
    },

    openRefundDialog() {
      let _ = this;
      // 重置表单; 充电用户/桩主手机号直接取 detailForm(已在 init() 加载), 无需额外请求
      _.refundForm = {
        orderNo: _.orderNo,
        refundReason: '',
        remark: '',
        chargerChecked: !_.chargerRefundDisabled, // 未分账默认可勾
        chargerAmt: 0,
        ownerChecked: false,
        ownerAmt: 0,
      };
      _.refundVisible = true;
    },
    // 退给充电用户 checkbox 变更: SETTLED时强制保持 false 且不提示超额
    onChargerChange(val) {
      if (this.chargerRefundDisabled && val) {
        this.refundForm.chargerChecked = false;
      }
    },

    submitRefund() {
      let _ = this;
      const f = _.refundForm;

      // ---- 提交前校验 ----
      if (!f.chargerChecked && !f.ownerChecked) {
        _.$U.error('请至少选择一个退款对象');
        return;
      }
      if (!f.refundReason) {
        _.$U.error('请选择退款原因');
        return;
      }
      if (f.chargerChecked && (!f.chargerAmt || f.chargerAmt <= 0)) {
        _.$U.error('请输入充电用户退款金额');
        return;
      }
      if (f.chargerChecked && Number(f.chargerAmt) > Number(_.refundableBalance)) {
        _.$U.error('充电用户退款金额超过可退余额');
        return;
      }
      if (f.ownerChecked && (!f.ownerAmt || f.ownerAmt <= 0)) {
        _.$U.error('请输入桩主退款金额');
        return;
      }

      // ---- 组装 refundTargets ----
      const refundTargets = [];
      if (f.chargerChecked) refundTargets.push({ target: 'CHARGER', amount: f.chargerAmt });
      if (f.ownerChecked) refundTargets.push({ target: 'OWNER', amount: f.ownerAmt });

      const payload = {
        orderNo: _.orderNo,
        refundTargets,
        refundReason: f.refundReason,
        remark: f.remark,
      };

      _.refundSubmitting = true;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.digitization.manualRefund, payload).then(res => {
        _.refundSubmitting = false;
        _.$U.hideLoading(_);
        const resp = (res.data && res.data.data) || {};
        // 拼装各对象结果 Toast
        const targetName = { CHARGER: '充电用户', OWNER: '桩主' };
        const statName = { P: '退款中', S: '已退款', F: '退款失败' };
        const lines = (resp.results || []).map(r =>
          `${targetName[r.target] || r.target}：${statName[r.transStat] || r.transStat}${r.failReason ? '(' + r.failReason + ')' : ''}`);
        const msg = `退款批次号 ${resp.batchNo || ''}，${lines.join('；')}`;
        // 含失败或处理中时用 error, 全成功用 success
        const hasFail = (resp.results || []).some(r => r.transStat === 'F');
        const hasPending = (resp.results || []).some(r => r.transStat === 'P');
        if (hasFail || hasPending) _.$U.error(msg); else _.$U.success(msg);

        _.refundVisible = false;
        _.init(); // 刷新两张明细表
        // 充电用户为异步(P), 启动轮询直到无 P 或超时
        if (hasPending) _.startRefundPoll();
      }).catch(() => {
        _.refundSubmitting = false;
        _.$U.hideLoading(_);
      });
    },

    // 充电用户退款异步: 每 5s 拉一次详情刷新, 最长约 2min, 直到无 P 行
    startRefundPoll() {
      let _ = this;
      if (_.refundPollTimer) clearInterval(_.refundPollTimer);
      let times = 0;
      const MAX = 24; // 24 * 5s = 120s
      _.refundPollTimer = setInterval(() => {
        times++;
        _.$H.post(_, _.$A.digitization.getChargeOrderInfo, { orderNo: _.orderNo }).then(res => {
          const list = (res.data && res.data.data) || {};
          _.afterSalePayFeeInfo = list.afterSalesRefundFeeDetail || [];
          const stillPending = _.afterSalePayFeeInfo.some(r => r.transStat === 'P');
          if (!stillPending || times >= MAX) {
            clearInterval(_.refundPollTimer);
            _.refundPollTimer = null;
          }
        }).catch(() => {
          if (times >= MAX) { clearInterval(_.refundPollTimer); _.refundPollTimer = null; }
        });
      }, 5000);
    },
  },
  beforeDestroy() {
    if (this.refundPollTimer) { clearInterval(this.refundPollTimer); this.refundPollTimer = null; }
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
/* 已分账时退给充电用户 checkbox 置灰 */
.charger-disabled >>> .el-checkbox__input,
.charger-disabled >>> .el-checkbox__label {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.charger-disabled >>> .el-checkbox__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
}
</style>